import { motion } from "framer-motion";

const PrivacyPage = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] }
  };

  return (
    <div className="min-h-screen pt-20" data-testid="privacy-page">
      <section className="py-16 md:py-24 bg-white">
        <div className="container-main">
          <motion.div {...fadeInUp} className="max-w-3xl mx-auto">
            <p className="caption mb-4">Legal</p>
            <h1 className="heading-1 mb-8">Privacy Policy</h1>
            
            <div className="prose prose-zinc max-w-none">
              <p className="body-lg mb-8">
                Last updated: December 2025
              </p>

              <div className="space-y-8 body-text">
                <section>
                  <h2 className="heading-3 mb-4">1. Information We Collect</h2>
                  <p>
                    We collect information you provide directly to us, such as when you create an account, 
                    use our applications, or contact us for support. This may include:
                  </p>
                  <ul className="list-disc pl-6 mt-4 space-y-2">
                    <li>Name and email address</li>
                    <li>Usage data and preferences</li>
                    <li>Content you create within our apps</li>
                    <li>Device information and identifiers</li>
                  </ul>
                </section>

                <section>
                  <h2 className="heading-3 mb-4">2. How We Use Your Information</h2>
                  <p>We use the information we collect to:</p>
                  <ul className="list-disc pl-6 mt-4 space-y-2">
                    <li>Provide, maintain, and improve our services</li>
                    <li>Process transactions and send related information</li>
                    <li>Send technical notices, updates, and support messages</li>
                    <li>Respond to your comments, questions, and requests</li>
                    <li>Develop new products, services, and features</li>
                  </ul>
                </section>

                <section>
                  <h2 className="heading-3 mb-4">3. Information Sharing</h2>
                  <p>
                    We do not sell, trade, or otherwise transfer your personal information to third parties. 
                    We may share information only in the following circumstances:
                  </p>
                  <ul className="list-disc pl-6 mt-4 space-y-2">
                    <li>With your consent</li>
                    <li>To comply with legal obligations</li>
                    <li>To protect our rights and prevent fraud</li>
                    <li>With service providers who assist in our operations</li>
                  </ul>
                </section>

                <section>
                  <h2 className="heading-3 mb-4">4. Data Security</h2>
                  <p>
                    We implement appropriate technical and organizational measures to protect your personal 
                    information against unauthorized access, alteration, disclosure, or destruction.
                  </p>
                </section>

                <section>
                  <h2 className="heading-3 mb-4">5. Your Rights</h2>
                  <p>You have the right to:</p>
                  <ul className="list-disc pl-6 mt-4 space-y-2">
                    <li>Access your personal information</li>
                    <li>Correct inaccurate information</li>
                    <li>Request deletion of your data</li>
                    <li>Opt out of marketing communications</li>
                  </ul>
                </section>

                <section>
                  <h2 className="heading-3 mb-4">6. Contact Us</h2>
                  <p>
                    If you have any questions about this Privacy Policy, please contact us at{" "}
                    <a href="mailto:info@theappfam.com" className="text-zinc-900 underline underline-offset-4">
                      info@theappfam.com
                    </a>
                  </p>
                </section>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPage;
